import type { DirectoryPanelProps } from './types';
import { Directory } from 'Components/DirectoryPanel/Directory';
import { STORE_PERSON } from 'Constants/stores';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Styled } from './index.styles';

const DirectoryPanelObserver: React.FC<DirectoryPanelProps> = ({
  person: { IsLoggedIn },
}) => {
  if (!IsLoggedIn) {
    return null;
  }

  return (
    <Styled.GridColumn id="action-panel">
      <Directory />
    </Styled.GridColumn>
  );
};

export const DirectoryPanel = inject(STORE_PERSON)(
  observer(DirectoryPanelObserver)
);
